import React from "react";
import { Box, ButtonBase, Typography } from "@mui/material";
import { focusRing, tokens } from "../../utils/figmaTokens";
import { countText } from "../../utils/kitPresentation";

// Tabs (11357:27979; first user: Money → Transactions, 044 D50–D59): a pill track of tabs, each
// carrying its own count. The chosen tab is white with a border; the others sit flat on the
// track. Scrolls sideways on a narrow screen rather than wrapping.
const SegmentTabs = ({ label, tabs, value, counts = {}, onChange }) => (
  <Box
    role="group"
    aria-label={label}
    sx={{
      display: "flex",
      gap: "4px",
      p: "4px",
      borderRadius: "999px",
      bgcolor: tokens.surface.muted,
      overflowX: "auto",
      flexWrap: "nowrap",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" },
    }}
  >
    {tabs.map((tab) => {
      const on = tab.key === value;
      const count = counts[tab.key];
      return (
        <ButtonBase
          key={tab.key}
          onClick={() => onChange(tab.key)}
          aria-pressed={on}
          disableRipple
          sx={{
            gap: "6px",
            px: "12px",
            py: "7px",
            borderRadius: "999px",
            border: `1px solid ${on ? tokens.border.default : "transparent"}`,
            bgcolor: on ? tokens.surface.default : "transparent",
            whiteSpace: "nowrap",
            flexShrink: 0,
            "&:hover": { bgcolor: on ? tokens.surface.default : tokens.hover },
            ...focusRing,
          }}
        >
          <Typography
            component="span"
            sx={{
              fontSize: 14,
              lineHeight: on ? "20px" : "22px",
              fontWeight: on ? 600 : 400,
              color: on ? tokens.text.primary : tokens.text.secondary,
            }}
          >
            {tab.label}
          </Typography>
          {count !== undefined && (
            <Typography
              component="span"
              sx={{ fontSize: 12, lineHeight: "16px", fontWeight: 600, color: on ? tokens.brand.text : tokens.text.tertiary }}
            >
              {count === null ? "—" : countText(count)}
            </Typography>
          )}
        </ButtonBase>
      );
    })}
  </Box>
);

export default SegmentTabs;
